import { render } from "./insights-card.vue?vue&type=template&id=88177b4a&scoped=true&ts=true"
import script from "./insights-card.vue?vue&type=script&lang=ts"
export * from "./insights-card.vue?vue&type=script&lang=ts"

import "./insights-card.vue?vue&type=style&index=0&id=88177b4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88177b4a"]])

export default __exports__